/**
 * If parameter ?h=1 is set change the last navigation history to the referer
 *
 */

const getUrlParameter = (name) => {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    const results = regex.exec(location.search);

    return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

const cleanRefererMobileURL = (url) => {
    const hostname = window.location.hostname;
    const hostNameIndex = url.indexOf(hostname);

    if (hostNameIndex !== -1 && url.indexOf('m.') >= 0) {
        return url.replace('m.' + hostname, hostname);
    } else {
        return url;
    }
};

// Check if URL is from the same origin
const isSameOrigin = (url) => {
    try {
        const urlObj = new URL(url);
        return urlObj.origin === window.location.origin;
    } catch (e) {
        return false;
    }
};

const isHistoryParameterSet = !!getUrlParameter('h');

if (typeof window.history.pushState === 'function' && typeof window.history.replaceState === 'function') {
    window.onpopstate = function(event) {
        if (event.state && typeof event.state && event.state.href) {
            window.location.href = event.state.href;
        }
    };

    if (isHistoryParameterSet) {
        const currentPath = window.location.href;
        // Clean referrer
        const referrer = cleanRefererMobileURL(document.referrer);

        // Only manipulate history if referrer is from the same origin
        if (referrer && isSameOrigin(referrer)) {
            window.history.replaceState({ href: referrer }, null, referrer);
            window.history.pushState({ href: currentPath }, null, currentPath);
        } else {
            // If referrer is from different origin, just push current state
            window.history.pushState({ href: currentPath }, null, currentPath);
        }
    }
}
